/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Structure:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Home',
    slug: 'home',
    icon: 'HomeIcon'
  },
  {
    url: '/dashboard',
    name: 'Dashboard',
    slug: 'dashboard',
    icon: 'MonitorIcon'
  },
  {
    url: '/floor',
    name: 'Production Floor',
    slug: 'production-floor',
    icon: 'MapIcon'
  },
  {
    url: '/batch',
    name: 'Batch Explorer',
    slug: 'batch-explorer',
    icon: 'SearchIcon'
  },
  {
    url: '/work-center',
    name: 'Work Center',
    slug: 'work-center',
    icon: 'InboxIcon'
  },
  {
    url: '/materials',
    name: 'Materials',
    slug: 'materials',
    icon: 'PackageIcon'
  },

  {
    header: 'Process',
    icon: 'UserIcon',
    items: [
      {
        url: '/process/furnace',
        name: 'Furnace Process',
        slug: 'process-furnace',
        icon: 'LayersIcon'
      },
      {
        url: '/process/press',
        name: 'Press Process',
        slug: 'process-press',
        icon: 'LayersIcon'
      },
      {
        url: '/process/roller',
        name: 'Roller Process',
        slug: 'process-roller',
        icon: 'LayersIcon'
      },
      {
        url: '/process/draw',
        name: 'Drawing Process',
        slug: 'process-drawing',
        icon: 'LayersIcon'
      },
      {
        url: '/process/wind',
        name: 'Winding Process',
        slug: 'process-winding',
        icon: 'LayersIcon'
      },
      {
        url: '/process/ipqc',
        name: 'IPQC',
        slug: 'process-ipqc',
        icon: 'LayersIcon'
      }
    ]
  },

  {
    header: 'Staging',
    icon: 'DatabaseIcon',
    items: [
      {
        url: '/staging/form',
        name: 'PRD Form',
        slug: 'staging-form',
        icon: 'BookOpenIcon'
      },
      {
        url: '/staging/message',
        name: 'MESSAGE Table',
        slug: 'staging-message',
        icon: 'MessageSquareIcon'
      },
      {
        url: '/staging/bom',
        name: 'A100BOM',
        slug: 'staging-bom',
        icon: 'PackageIcon'
      },
      {
        url: '/staging/prod',
        name: 'A100PROD',
        slug: 'staging-prod',
        icon: 'ClipboardIcon'
      },
      {
        url: '/staging/route',
        name: 'A100ROUTE',
        slug: 'staging-route',
        icon: 'GitPullRequestIcon'
      },
      {
        url: '/staging/raf',
        name: 'R200RAF',
        slug: 'staging-raf',
        icon: 'LoaderIcon'
      },
      {
        url: '/staging/pick',
        name: 'R200PICKINGLIST',
        slug: 'staging-pick',
        icon: 'ListIcon'
      },
      {
        url: '/staging/card',
        name: 'R200ROUTECARD',
        slug: 'staging-card',
        icon: 'CreditCardIcon'
      }
    ]
  },
  {
    header: 'Access Management',
    icon: 'UserIcon',
    items: [
      {
        url: '/users',
        name: 'User List',
        slug: 'user-list',
        icon: 'UsersIcon'
      },
      {
        url: '/activity',
        name: 'User Activity',
        slug: 'user-activity',
        icon: 'ActivityIcon'
      }
    ]
  },
  {
    header: 'Configuration',
    icon: 'SettingsIcon',
    items: [
      {
        url: '/setting',
        name: 'Setting',
        slug: 'setting',
        icon: 'SettingsIcon'
      }
    ]
  }
]
